
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import LatexRenderer from '../LatexRenderer';

const MathBlockNode = (props: any) => {
  const { node, updateAttributes, selected } = props;
  const { onMathDoubleClick } = props.extension.options;

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onMathDoubleClick) {
      const initialValue = node.attrs.latex;
      const onSave = (newValue: string) => {
        // The popup returns the full string with delimiters, so we extract the content.
        const content = newValue.startsWith('$$') ? newValue.substring(2, newValue.length - 2) : newValue;
        updateAttributes({ latex: content });
      };
      // Pass the value with delimiters to the popup
      onMathDoubleClick(`$$${initialValue}$$`, onSave);
    }
  };

  return (
    <NodeViewWrapper className="is-draggable" onDoubleClick={handleDoubleClick}>
        <div className="drag-handle" contentEditable="false" draggable="true" data-drag-handle>
            ⠿
        </div>
        <div 
          className={`math-block-content p-2 rounded cursor-pointer ${selected ? 'ProseMirror-selectednode' : ''}`}
          contentEditable={false}
        >
          {/* We add delimiters for LatexRenderer, but store only the content */}
          <div className="pointer-events-none">
             <LatexRenderer latex={`$$${node.attrs.latex}$$`} />
          </div>
        </div>
    </NodeViewWrapper>
  );
};

export default MathBlockNode;
